/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CartDto } from './CartDto';
import {
    CartDtoFromJSON,
    CartDtoFromJSONTyped,
    CartDtoToJSON,
} from './CartDto';
import type { DeliveryPointDto } from './DeliveryPointDto';
import {
    DeliveryPointDtoFromJSON,
    DeliveryPointDtoFromJSONTyped,
    DeliveryPointDtoToJSON,
} from './DeliveryPointDto';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface PayCartDto
 */
export interface PayCartDto {
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof PayCartDto
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {number}
     * @memberof PayCartDto
     */
    tipAmount: number;
    /**
     * 
     * @type {DeliveryPointDto}
     * @memberof PayCartDto
     */
    deliveryPoint: DeliveryPointDto;
    /**
     * 
     * @type {string}
     * @memberof PayCartDto
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof PayCartDto
     */
    deliveryMethodId: number;
    /**
     * 
     * @type {string}
     * @memberof PayCartDto
     */
    discountCode?: string;
    /**
     * 
     * @type {number}
     * @memberof PayCartDto
     */
    placementId?: number;
    /**
     * 
     * @type {string}
     * @memberof PayCartDto
     */
    deviceId: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PayCartDto
     */
    dynamicFields?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PayCartDto
     */
    giftCardPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PayCartDto
     */
    vatType: PayCartDtoVatTypeEnum;
    /**
     * 
     * @type {CartDto}
     * @memberof PayCartDto
     */
    cart: CartDto;
}


/**
 * @export
 */
export const PayCartDtoVatTypeEnum = {
    TAKEAWAY: 'TAKEAWAY',
    EAT_IN: 'EAT_IN'
} as const;
export type PayCartDtoVatTypeEnum = typeof PayCartDtoVatTypeEnum[keyof typeof PayCartDtoVatTypeEnum];


/**
 * Check if a given object implements the PayCartDto interface.
 */
export function instanceOfPayCartDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "tipAmount" in value;
    isInstance = isInstance && "deliveryPoint" in value;
    isInstance = isInstance && "deliveryMethodId" in value;
    isInstance = isInstance && "deviceId" in value;
    isInstance = isInstance && "vatType" in value;
    isInstance = isInstance && "cart" in value;

    return isInstance;
}

export function PayCartDtoFromJSON(json: any): PayCartDto {
    return PayCartDtoFromJSONTyped(json, false);
}

export function PayCartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayCartDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'tipAmount': json['tipAmount'],
        'deliveryPoint': DeliveryPointDtoFromJSON(json['deliveryPoint']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'deliveryMethodId': json['deliveryMethodId'],
        'discountCode': !exists(json, 'discountCode') ? undefined : json['discountCode'],
        'placementId': !exists(json, 'placementId') ? undefined : json['placementId'],
        'deviceId': json['deviceId'],
        'dynamicFields': !exists(json, 'dynamicFields') ? undefined : json['dynamicFields'],
        'giftCardPhoneNumber': !exists(json, 'giftCardPhoneNumber') ? undefined : json['giftCardPhoneNumber'],
        'vatType': json['vatType'],
        'cart': CartDtoFromJSON(json['cart']),
    };
}

export function PayCartDtoToJSON(value?: PayCartDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'tipAmount': value.tipAmount,
        'deliveryPoint': DeliveryPointDtoToJSON(value.deliveryPoint),
        'comment': value.comment,
        'deliveryMethodId': value.deliveryMethodId,
        'discountCode': value.discountCode,
        'placementId': value.placementId,
        'deviceId': value.deviceId,
        'dynamicFields': value.dynamicFields,
        'giftCardPhoneNumber': value.giftCardPhoneNumber,
        'vatType': value.vatType,
        'cart': CartDtoToJSON(value.cart),
    };
}

